import Region from '@/creditflowresearch/domain/Region';

export enum FieldsNames {
  Regions = 'regionIds',
  Markets = 'marketIds',
  Products = 'productIds',
  Segments = 'marketSegments',
}

/** The fields holding a flat id list — everything except the segment groups. */
export type TIdListFieldName = Exclude<FieldsNames, FieldsNames.Segments>;

export interface IEntity {
  getAbbreviation: () => string,
  getDisplayName: () => string,
  canAccess: (accessibleIds: string[] | Set<string>) => boolean,
  belongsToRegion?: () => Region | null,
}

export interface IBasePreferenceItem {
  id: string,
  fieldName: FieldsNames,
  getEntity: () => IEntity | null,
  isDefault?: boolean,
  /** Segments only: the row this toggle edits. Unset on the dropdown's merged row. */
  scopeId?: string,
}

export interface IPreferenceItem extends IBasePreferenceItem {
  children?: IBasePreferenceItem[],
}
